import { render } from "./contentBorderTow.vue?vue&type=template&id=78ad4d60"
import script from "./contentBorderTow.vue?vue&type=script&lang=js"
export * from "./contentBorderTow.vue?vue&type=script&lang=js"

import "./contentBorderTow.vue?vue&type=style&index=0&id=78ad4d60&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__